import { Guid } from '../../classes/guid';
import { MicroTaskConfigType } from '../../types/micro-task-config-type';
import { RateLimiterRelease } from './rate-limiter-release';
import { IRecord } from './record';

export class CommandPayload {
	executionID = Guid();
	isSync = false;
	/**
	 * The `isSync` of the trigger, kept when a loop forces `isSync` to true for its branches. Undefined
	 * everywhere else. `originalIsSync ?? isSync` is whether a caller is really waiting for the result.
	 */
	originalIsSync?: boolean;
	/**
	 * Set on a command that a rate limiter sends back to itself once it has taken a slot for an execution
	 * from its backlog, so that the limiter lets it through instead of counting and checking it again.
	 */
	rateLimiterRelease?: RateLimiterRelease;
	records: IRecord[] = [];
	isSimulation?: boolean;
	isSingleTask?: boolean;
	error?: string;
	accessToken?: string;
	config?: MicroTaskConfigType;
	sourceTaskID?: string;
	flowID?: string;
	loopIteration: number = 0;
	sessionUserID: string = '';
	flowVariables?: { [key: string]: unknown };

	constructor(commandPayloadProps?: Partial<CommandPayload>) {
		if (commandPayloadProps) {
			Object.assign(this, commandPayloadProps);
		}
	}
}
